/**
 * 桥梁状态管理工具
 * 用于在数据看板页面及其子页面之间共享桥梁选择状态
 */

const BRIDGE_STORAGE_KEY = 'analytics_current_bridge_id'
const BRIDGE_LIST_STORAGE_KEY = 'analytics_bridge_list'

export default {
  /**
   * 获取当前选中的桥梁ID
   * @returns {number|null} 桥梁ID
   */
  getCurrentBridgeId() {
    const bridgeId = localStorage.getItem(BRIDGE_STORAGE_KEY)
    return bridgeId ? parseInt(bridgeId, 10) : null
  },

  /**
   * 设置当前选中的桥梁ID
   * @param {number} bridgeId 桥梁ID
   */
  setCurrentBridgeId(bridgeId) {
    if (bridgeId) {
      localStorage.setItem(BRIDGE_STORAGE_KEY, bridgeId.toString())
    } else {
      localStorage.removeItem(BRIDGE_STORAGE_KEY)
    }
  },

  /**
   * 获取桥梁列表
   * @returns {Array} 桥梁列表
   */
  getBridgeList() {
    const bridgeListStr = localStorage.getItem(BRIDGE_LIST_STORAGE_KEY)
    return bridgeListStr ? JSON.parse(bridgeListStr) : []
  },

  /**
   * 设置桥梁列表
   * @param {Array} bridgeList 桥梁列表
   */
  setBridgeList(bridgeList) {
    if (bridgeList && bridgeList.length > 0) {
      localStorage.setItem(BRIDGE_LIST_STORAGE_KEY, JSON.stringify(bridgeList))
    }
  },

  /**
   * 获取当前选中的桥梁信息
   * @returns {Object|null} 桥梁信息对象
   */
  getCurrentBridge() {
    const currentId = this.getCurrentBridgeId()
    if (!currentId) return null

    const bridgeList = this.getBridgeList()
    return bridgeList.find(bridge => bridge.id === currentId) || null
  },

  /**
   * 清除所有桥梁状态
   */
  clearBridgeState() {
    localStorage.removeItem(BRIDGE_STORAGE_KEY)
    localStorage.removeItem(BRIDGE_LIST_STORAGE_KEY)
  },

  /**
   * 监听桥梁状态变化
   * @param {Function} callback 回调函数
   */
  onBridgeChange(callback) {
    const handler = (e) => {
      if (e.key === BRIDGE_STORAGE_KEY) {
        const newBridgeId = e.newValue ? parseInt(e.newValue, 10) : null
        callback(newBridgeId)
      }
    }
    window.addEventListener('storage', handler)
    return () => window.removeEventListener('storage', handler)
  }
}

